const config = { ...window.Settings, ...window.ApiPaths };

export default config;
